// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@tps/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h1",
    as: "p",
    css: css`
        margin-bottom: 20px;
    `,
};
headerStyles.orderNumberHeading = {
    variant: "h2",
    forwardAs: "p",
    css: css`
        margin-bottom: 16px;
    `,
};
headerStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 8px;
            margin-bottom: 16px;
        `,
    },
    heading: {
        lineHeight: "19px",
        weight: "bold",
        size: 14,
        transform: "capitalize",
    },
    text: {
        lineHeight: "22px",
        weight: "normal",
        size: 14,
    },
};
headerStyles.customMsg = {
    forwardAs: "p",
    lineHeight: "22px",
    weight: "normal",
    size: 14,
    css: css`
        margin-bottom: 16px;
    `,
};
headerStyles.buttonGridItem = {
    css: css`
        display: flex;
        column-gap: 32px;
        ${xScreen("lte", "md")} {
            justify-content: space-between;
        }
    `,
};
headerStyles.continueButton = {
    css: css``,
};
headerStyles.printButton = {
    variant: "secondary",
};

headerStyles.creditHoldWarning = {
    forwardAs: "p",
    lineHeight: "22px",
    weight: "normal",
    size: 14,
    css: css`
        margin-bottom: 8px;
    `,
};